import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _PropTypes from 'prop-types';
import styled from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["children", "color", "size", "title"];
var StyledSvg = styled.svg.withConfig({
  displayName: "Base__StyledSvg",
  componentId: "sc-8jojep-0"
})(["&&{display:inline-block;fill:none;line-height:1;vertical-align:middle;flex:none;}&& path{stroke-width:", ";}[dir='rtl'] &&[data-mntl-flip-svg='true']{transform:scaleX(-1);}"], function (props) {
  return props.height < 20 ? "2px" : "1.5px";
});
var defaultSize = 24;

var Svg = function Svg(_ref) {
  var children = _ref.children;
      _ref.color;
      var _ref$size = _ref.size,
      size = _ref$size === void 0 ? defaultSize : _ref$size,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/jsxs(StyledSvg, _objectSpread(_objectSpread({
    "aria-hidden": true,
    focusable: "false",
    height: size,
    width: size
  }, props), {}, {
    children: [title && /*#__PURE__*/jsx("title", {
      children: title
    }), children]
  }));
};

Svg.propTypes = {
  "children": _PropTypes.node,
  "color": _PropTypes.string,
  "size": _PropTypes.oneOf([16, 20, 24, 32]),
  "title": _PropTypes.string
};
Svg.displayName = "Svg";

export { StyledSvg, Svg };
